import styled, { css } from 'styled-components';
import { SelectDto } from '../model/common.dto';
import { Icon } from './Icon';

interface SelectProps {
  theme: string;
  width: string;
  value: string;
  setValue: (value: string) => void;
  options: SelectDto[];
}

const Select = ({ theme, width, value, setValue, options }: SelectProps) => {
  return (
    <>
      <Wrap $theme={theme} $width={width}>
        <select value={value} onChange={(e) => setValue(e.target.value)}>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="img-box">
          <Icon name="ArrowBottomIcon" size="100%" color="#D8D7DC" />
        </span>
      </Wrap>
    </>
  );
};

export default Select;

const Wrap = styled.div<{
  $theme: string;
  $width: string;
}>`
  position: relative;
  > select {
    width: ${({ $width }) => $width};
    min-width: ${({ $width }) => $width};
    box-sizing: border-box;
    position: relative;
    ${({ $theme }) => {
      if ($theme === 'type1') {
        return css`
          height: 36px;
          border-radius: 4px;
          background-color: #fff;
          border: 1px solid #d6dbe1;
          color: #111;
          padding: 0 32px 0 12px;
          font-size: 14px;
        `;
      }
    }}
  }
  > .img-box {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
  }
`;
